import {Link} from "react-router-dom";
import {cn} from "~/lib/utils";
import {Card, CardContent, CardFooter, CardHeader, CardTitle} from "@sakura-grp/ui/card";
import {global_logo_svg} from "~/assets/image-size-mapping";
import AppPicture from "~/components/react/AppPicture.tsx";
import GoogleLogin from "@/components/react/GoogleLogin.tsx";
import EmailLogin from "@/components/react/EmailLogin.tsx";

interface Props extends React.ComponentProps<"div"> {}

export function LoginForm({className, ...props}: Props) {

  return (
    <div className={cn("flex flex-col gap-6", className)} {...props}>
      <Card className="shadow-2xl border-stone-200/60 pb-5">
        <CardHeader className="pb-2">
          <CardTitle className="flex flex-col items-center gap-3">
            <figure className="relative flex justify-center">
              <div className="absolute -inset-4 rounded-full bg-brand/10 blur-2xl" />
              <strong className="sr-only">SAKURA GROUP HOLDINGS.</strong>
              <AppPicture aria-hidden="true" img={global_logo_svg} sources={[["default", {}]]} imgClass="relative w-[10rem] h-auto mx-auto" alt="SAKURA GROUP HOLDINGS." loading="eager" />
            </figure>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col gap-3">
            {import.meta.env.DEV && (
              <>
                <EmailLogin />
                <div className="relative my-2">
                  <div className="absolute inset-0 flex items-center">
                    <span className="w-full border-t border-stone-300" />
                  </div>
                  <div className="relative flex justify-center text-xs">
                    <span className="bg-card px-2 text-stone-500">または</span>
                  </div>
                </div>
              </>
            )}
            <GoogleLogin />
          </div>
        </CardContent>
        <CardFooter className="mt-3 justify-center">
          <Link
            to="/privacy"
            className="text-xs text-stone-500 transition-colors hover:text-stone-900"
          >
            プライバシーポリシー
          </Link>
        </CardFooter>
      </Card>
    </div>
  );
}
